import { Injectable } from "@angular/core";
import { IsFirstTimeDataRepo } from "@app/core/user/data/repository/is-first-time-data.repo";

@Injectable({
  providedIn: "root",
})
export class IsAppFirstTimeOpenedUseCase {
  constructor(private isFirstTimeDataRepo: IsFirstTimeDataRepo) {}
  execute(): boolean {
    return this.isFirstTimeDataRepo.getIsFirstTime();
  }
}
